import React, { useEffect, useState } from "react";
import {
  Modal /*,
    Button*/,
} from "react-bootstrap";

import styled from "styled-components";
import useWindowBreakpoint from "../components/hooks/UseWindowBreakpoint";

const CustomModal = styled(Modal)`
  .modal-lg {
    max-width: ${({ modalwidth }) => modalwidth};
  }
  .modal-header {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
  .modal-body {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
  .card-header {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
  .card-body {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
`;

export const ModalContext = React.createContext(null);
export default function ModalProvider({ children }) {
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [modalWidth, setModalWidth] = useState("800px");

  const breakpoint = useWindowBreakpoint();

  useEffect(() => {
    // Si el viewport es pequeño ocultamos y si no mostramos
    if (["xs", "sm"].includes(breakpoint)) {
      setModalWidth("auto");
    } else {
      setModalWidth("80%");
    }
  }, [breakpoint]);

  // Recibe el estado del modal, true or false para mostrar la ventana
  // y recibe el tamaño de pantalla que ocupa el modal
  const showModal = (state, width) => {
    setShow(state);
    if (state) {
      // Si esta en formato movil lo cambiamos siempre a automático
      if (["xs", "sm"].includes(breakpoint)) {
        setModalWidth("auto");
      } else {
        setModalWidth(width);
      }
    }
  };


  //Estado con las funciones que permiten interactuar con la ventana modal
  const state = {
    modalSetShow: showModal,
    modalSetTitle: setTitle,
    modalSetContent: setContent,
    show: show,
  };


  return (
    <ModalContext.Provider value={state}>
      <CustomModal
        modalwidth={modalWidth}
        show={show}
        size="lg"
        scrollable
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{content}</Modal.Body>
        {/*<Modal.Footer>
                    <Button
                        variant="outline-primary"
                        onClick={() => {
                            setShow(false);
                        }}
                        name="Close"
                    >
                        Cerrar
                    </Button>
                </Modal.Footer>*/}
      </CustomModal>
      {children}
    </ModalContext.Provider>
  );
}